// import axios from "axios";
import * as urls from "./URLConst";
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  getClientData,
  setLocalAccessToken,
  setLocalRefreshToken,
  AuthKey,
} from "./Common";

import axios from "axios";
import { computeCrc } from "./CRC32";
import toastNotify from "./ToastNotify";


var getChecksumValue = null;

const axiosInstance = axios.create({
  baseURL: urls.BaseUrl,
  headers: {
    "Content-Type": "application/json",
    'Authorization': 'Basic ' + process.env.REACT_APP_BASIC_AUTH_KEY,
  }
});

axiosInstance.interceptors.request.use(
  async (config) => {
    if (getChecksumValue) {
      config.headers["checksum"] = await getChecksumValue;
    }
    const accessToken = getLocalAccessToken();
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {

    if (!error.response) {
      // Handle network errrs or cases where reposnse is not available
      if (window.location.pathname !== "/") {
        window.location.href = "/"
      }
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    // check if the error is due to in expired access token
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;

      // // Use your token refresh logic here
      const refreshToken = getLocalRefreshToken();

      // // Example: Refresh token logic using an API call
      await refreshAccessToken(refreshToken);


      // retry the original request with the new access token
      const accessToken = getLocalAccessToken();

      if (accessToken) {
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
      }

      // Here Update new Login Token in payload 
      if (originalRequest.data) {
        const newRefreshToken = getLocalRefreshToken();
        const parsed = JSON.parse(originalRequest.data);

        if (parsed.LOGIN_TOKEN) {
          parsed.LOGIN_TOKEN = newRefreshToken;
          originalRequest.data = JSON.stringify(parsed);
        }
      }

      return axios(originalRequest);
    };
    return Promise.reject(error);
  },
);

// Function to refresh access token using your authentication service
const refreshAccessToken = async (refreshToken) => {
  const client = getClientData();
  const identifyData = JSON.parse(localStorage.getItem("_identityData"));

  const payload = {
    REFRESH_TOKEN: refreshToken,
    MOBILE_NO: client.MOBILE_NO1,
    DOMAIN_NM: window.location.hostname,
    CUSTOMER_CD: client.CUSTOMER_CD,
    CUSTOMER_USER_CD: client.CUSTOMER_USER_CD,
    COMP_CD: client.COMP_ID,
    LOGIN_TOKEN: refreshToken,
    IP_ADDRESS: identifyData.ip,
  };

  await axios({
    method: "POST",
    url: urls.RefreshTokenUrl,
    data: payload,
    headers: {
      "Content-Type": "application/json",
      "Authorization": AuthKey,
    },
  }).then((response) => {
    setLocalAccessToken(response.data.RESPONSE[0].ACCESS_TOKEN);
    setLocalRefreshToken(response.data.RESPONSE[0].REFRESH_TOKEN);

    return response.data.RESPONSE[0].REFRESH_TOKEN;
  }).catch(async (error) => {
    return window.location.pathname !== "/session-expire" ? window.location.href = "/session-expire" : "";
  });
};


const makeRequest = async (
  method,
  endpoint,
  data = null,
  config = {}) => {

  const client = getClientData();
  const refreshToken = getLocalRefreshToken();
  const identifyData = JSON.parse(localStorage.getItem("_identityData"));

  try {
    const payload = {
      ...data,
      MOBILE_NO: client?.MOBILE_NO1,
      DOMAIN_NM: window.location.hostname,
      CUSTOMER_CD: client?.CUSTOMER_CD,
      COMP_CD: client?.COMP_ID,
      LOGIN_TOKEN: refreshToken,
      IP_ADDRESS: identifyData.ip,
      CUSTOMER_USER_CD: client?.CUSTOMER_USER_CD,
    };

    const checksum = computeCrc(JSON.stringify(payload));

    const response = await axiosInstance({
      method,
      url: endpoint,
      data: payload,
      ...{
        ...config,
        headers: {
          checksum: checksum,
        },
      },
    });

    // Handle successful reposnse
    if (response.data.STATUS === "3") {
      return window.location.pathname !== "/sessionout" ? window.location.href = "/sessionout" : "";
    } else {
      return response.data;
    }
  } catch (error) {

    toastNotify(error?.response?.data?.MESSAGE, "error");
    // toastNotify(error?.message, "error");

    if (error.status === 401) {
      window.location.href = "/session-expire";
    }
    console.log("error", error);
    throw new Error(error);
  }
};

export default makeRequest;